/**
 * FounderBadge — Small inline badge for users who joined during the founding season.
 */

import { View, Text, StyleSheet } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';
import { isFounder } from '@/constants/founding';
import { TYPO } from '@/constants/typography';

interface FounderBadgeProps {
  createdAt: string | null | undefined;
}

export default function FounderBadge({ createdAt }: FounderBadgeProps) {
  const { theme } = useTheme();
  const c = theme.colors;

  // Only render if user is a founder
  if (!createdAt || !isFounder(createdAt)) {
    return null;
  }

  return (
    <View style={[styles.container, { borderColor: c.accent, backgroundColor: 'transparent' }]}>
      <Text style={[styles.text, { color: c.accent }]}>
        FOUNDER
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderRadius: 2,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  text: {
    fontFamily: TYPO.subheading.bold,
    fontSize: 11,
    letterSpacing: 2,
    textTransform: 'uppercase',
  },
});